<template>
  <b-row>
    <b-col>
      <h6 class="compo-heading">{{ $t("configuration.configuration") }}</h6>
    </b-col>
  </b-row>
  <div class="checkbox-details-card">
    <b-row>
      <b-col lg="12" md="12" sm="12" cols="12">
        <!-- <n-space vertical>
                    <n-checkbox label="Required Expiry Date" v-model:checked="Configuration.ExpiryDtRequired" />
                    <n-checkbox label="Required Batch No" v-model:checked="Configuration.BatchRequired" />
                    <n-checkbox label="Is Non-Rechargable" v-model:checked="Configuration.IsNonChargable" />
                    <n-checkbox label="Is Consignee" v-model:checked="Configuration.IsConsignee" />
                    <n-checkbox label="No MRP" v-model:checked="Configuration.NoMrp" />
                    <n-checkbox label="Auto Consumed" v-model:checked="Configuration.AutoConsumed" />
                    <n-checkbox label="High Value" v-model:checked="Configuration.HighValueFlag" />
                    <n-checkbox label="X-Ray Films" v-model:checked="Configuration.IsxrayFilm" />
                    <n-checkbox label="Is GST Exempt" v-model:checked="Configuration.IsGSTExempt" />
                    <n-checkbox label="Asset" v-model:checked="Configuration.Asset" />
                </n-space> -->
        <div class="justify-content-center gap-5">
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="Configuration.ExpiryDtRequired" inputId="ingredient1" name="Required Expiry Date"
              value="true" :tabindex="28" />
            <label for="Required Expiry Date" class="ms-2">{{ $t("configuration.required expiry date") }}
            </label>
          </div>
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="Configuration.BatchRequired" inputId="ingredient2" name="Required Batch No" value="true"
              :tabindex="29" />
            <label for="Required Batch No" class="ms-2">
              {{ $t("configuration.required batch no") }}
            </label>
          </div>
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="Configuration.ManufactureDate" inputId="ingredient6" name="Manufacture Date" value="true"
              :tabindex="39" />
            <label for="Manufacture Date" class="ms-2">
              {{ $t("configuration.ManufactureDate") }}
            </label>
          </div>
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="Configuration.IsNonChargable" inputId="ingredient3" name="Is Non-Rechargable"
              value="true" :tabindex="30" />
            <label for="Is Non-Rechargable" class="ms-2">{{ $t("configuration.is non-rechargable") }}
            </label>
          </div>
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="Configuration.IsConsignee" inputId="ingredient4" name="Is Consignee" value="true"
              :tabindex="31" />
            <label for="Is Consignee" class="ms-2">{{
              $t("configuration.is consignee")
            }}</label>
          </div>
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="Configuration.NoMrp" inputId="ingredient4" name=" No MRP" value="true" :tabindex="32" />
            <label for="No MRP" class="ms-2">
              {{ $t("configuration.no mrp") }}
            </label>
          </div>
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="Configuration.AutoConsumed" inputId="ingredient1" name="Auto Consumed" value="true"
              :tabindex="33" />
            <label for="Auto Consumed" class="ms-2">{{
              $t("configuration.auto consumed")
            }}</label>
          </div>
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="Configuration.HighValueFlag" inputId="ingredient2" name="High Value" value="true"
              :tabindex="34" />
            <label for="High Value" class="ms-2">{{
              $t("configuration.high value")
            }}</label>
          </div>
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="Configuration.IsxrayFilm" inputId="ingredient3" name="X-Ray Films" value="true"
              :tabindex="35" />
            <label for="X-Ray Films" class="ms-2">
              {{ $t("configuration.x-ray films") }}
            </label>
          </div>
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="Configuration.IsGSTExempt" inputId="ingredient4" name="Is GST Exempt" value="true"
              :tabindex="36" />
            <label for="Is GST Exempt" class="ms-2">
              {{ $t("configuration.is gst exempt") }}
            </label>
          </div>
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="Configuration.Asset" inputId="ingredient4" name="Asset" value="true" :tabindex="37" />
            <label for="Asset" class="ms-2">
              {{ $t("configuration.asset") }}</label>
          </div>
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="Configuration.ServiceLevel" inputId="ingredient4" name="ServiceLevel" value="true"
              :tabindex="38" />
            <label for="ServiceLevel" class="ms-2">
              {{ $t("configuration.serviceLevel") }}
            </label>
          </div>
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="Configuration.IsProduct" inputId="ingredient4" name="Product" value="true"
              :tabindex="38" />
            <label for="Product" class="ms-2">
              {{ $t("configuration.Product") }}
            </label>
          </div>
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="Configuration.IsBrand" inputId="ingredient4" name="Brand" value="true" :tabindex="38" />
            <label for="Brand" class="ms-2">
              {{ $t("configuration.Brand") }}
            </label>
          </div>
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="Configuration.IsModel" inputId="ingredient4" name="Model" value="true" :tabindex="38" />
            <label for="Model" class="ms-2">
              {{ $t("configuration.Model") }}
            </label>
          </div>
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="Configuration.IsSize" inputId="ingredient4" name="Size" value="true" :tabindex="38" />
            <label for="Size" class="ms-2">
              {{ $t("configuration.Size") }}
            </label>
          </div>
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="Configuration.IsWorkOrder" inputId="ingredient4" name="IsWorkOrder" value="true"
              :tabindex="40" />
            <label for="Size" class="ms-2">
              {{ $t("configuration.IsWorkOrder") }}
            </label>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="8" md="10" sm="8" cols="10" class="my-3 mx-5">
        <!-- <n-input placeholder="Category/Grp/Sub Grp/Item" /> -->
        <div class="field">
          <TextField v-model="Configuration.ConfigValue" type="text" placeholder="Category/Grp/Sub Grp/Item" clearable
            name="" :tabindex="39" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, toRefs, onMounted } from "vue";
import TextField from "../../../../components/FormComponents/TextInput.vue";

export default defineComponent({
  components: {
    TextField,
  },
  props: {
    value: Object,
  },

  methods: {},

  setup(props, { emit }) {
    let Configuration = reactive({
      ExpiryDtRequired: false,
      BatchRequired: false,
      ManufactureDate: false,
      IsNonChargable: false,
      IsConsignee: false,
      NoMrp: false,
      AutoConsumed: false,
      HighValueFlag: false,
      IsxrayFilm: false,
      IsGSTExempt: false,
      Asset: false,
      ConfigValue: "",
      ServiceLevel: false,
      IsProduct: false,
      IsBrand: false,
      IsModel: false,
      IsSize: false,
      IsWorkOrder: false,
    });

    onMounted(() => {
      Object.assign(Object.assign(Configuration), props.value);
      input();
    });

    function input() {
      //emit('update:value', Configuration)
      emit("update:checked", Configuration);
    }

    return {
      selectedValue: ref(null),
      selectedArray: ref([]),
      options: [
        {
          label: "Select1",
          value: "select1",
        },
        {
          label: "Select2",
          value: "select2",
        },
        {
          label: "Select3",
          value: "select3",
        },
      ],

      Configuration,
      input,
    };
  },
});
</script>
<style lang="scss">
.checkbox-details-card {
  background-color: #fcfcfc;
  border: 1px solid #fafafa;
  padding: 15px;
  border-radius: 10px;
  font-size: 14px;
}
</style>
